import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import * as Icons from 'react-bootstrap-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Confirmation from './ConfirmationModal';

const PersonAdd = ({show, callback}) => {
    const [ addFormData, setAddFormData ] = useState({
        name: '',
        address: ''
      })
    
      const handleAddFormChange = (event) => {
        event.preventDefault();
    
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value;
    
        const newFormData = { ...addFormData };
        newFormData[fieldName] = fieldValue;
    
        setAddFormData(newFormData);
    
        console.log('handleSave-newFormData',newFormData)
      }
    
    
      const handleSave = (event) => {
        event.preventDefault();
        console.log('handleSave', addFormData)
        callback(addFormData);
      }
    
      const closeForm = () => {
        callback("close");
      }
    
      return (
        <>
          <Modal
            show={show}
            onHide={closeForm}
            backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Add Personnel</Modal.Title>
              </Modal.Header>
    
              <Modal.Body>
                <Form onSubmit={handleSave}>
                    <Form.Label>Organisaation</Form.Label>
                    <Form.Control name="organization_id" type="text" placeholder="Organisaatio id" onChange={handleAddFormChange} />
    
                    <Form.Label>Nimi</Form.Label>
                    <Form.Control name="name" type="text" placeholder="Nimi" onChange={handleAddFormChange} />
    
                    <Form.Label>Email</Form.Label>
                    <Form.Control name="email" type="text" placeholder="Email"  onChange={handleAddFormChange} />
    
                    <Form.Label>Puhelin</Form.Label>
                    <Form.Control name="phone" type="text" placeholder="Puhelinnumero"  onChange={handleAddFormChange} />
    
                    <Form.Label>Käyttäjätunnus</Form.Label>
                    <Form.Control name="username" type="text" placeholder="Username"  onChange={handleAddFormChange} />
    
                    <Form.Label>Salasana</Form.Label>
                    <Form.Control name="password" type="text" placeholder="Salasana"  onChange={handleAddFormChange} />
    
                    <Form.Label>Level</Form.Label>
                    <Form.Control name="level" type="text" placeholder="Level"  onChange={handleAddFormChange} />
    
                    {/*<Button type="submit">Save</Button>*/}
                </Form>
    
              </Modal.Body>
    
              <Modal.Footer>
                <Button onClick={closeForm}>Cancel</Button>
                <Button onClick={handleSave}>Save</Button>
              </Modal.Footer>
    
            </Modal>
        </>
      )
}


const ReadOnlyRow = ({ person, handleEditClick, handleDeleteRow, organizations }) => {
  // Comboboxin teksti = organisaation nimi
  var org_title = organizations.find(x => x.id === Number(person.organization_id)).name;

  const level_descriptions = [ {"level": 1, "description": "View"}, {"level": 2, "description": "Maintenance"}, {"level": 3, "description": "Admin"} ];


  return (
              

    <tr>
      <td><b>{person['id']}</b></td>
      <td><b>{org_title}</b></td>
      <td><b>{person['name']}</b></td>
      <td>{person['email']}</td>
      <td>{person['phone']}</td>
      <td>{person['username']}</td>
      <td>{person['password']}</td>
      <td>{(person['level'] !== undefined ? person['level'] + ' - ' + level_descriptions.find(x => x.level === Number(person['level']))['description'] : '')}</td>
      <td>
        <button class="btn btn-primary" title="Edit" onClick={(event) => handleEditClick(event, person)}><Icons.Pencil /></button>
        <button class="btn btn-primary" title="Delete" onClick={() => handleDeleteRow(person['id'])}><Icons.Trash/></button>
      </td>
    </tr>
  )
}



// Editoitava organization rivi
const EditableRow = ({ editFormData, handleEditFormChange, handleCancelClick, handleEditFormSelect, organizations }) => {

  // Comboboxin teksti = organisaation nimi
  var org_title = organizations.find(x => x.id === Number(editFormData.organization_id)).name;

  // Comboboxissa näytettävät organisaatiot
  var org_items = [];
  {organizations.map((org) => {
    org_items = org_items.concat(<Dropdown.Item name="organization_id" eventKey={org.id} >{org.name}</Dropdown.Item>);

  })}

  const level_descriptions = [ {"level": 1, "description": "View"}, {"level": 2, "description": "Maintenance"}, {"level": 3, "description": "Admin"} ];


  return (
    <tr>
      <td><b>{editFormData.id}</b></td>
      {/*<td><b><input type="text" required="required" placeholder="Enter organization id" name="organization_id" value={editFormData.name} onChange={handleEditFormChange} ></input></b></td> */}
      <td>
        <DropdownButton title={org_title} onSelect={handleEditFormSelect}>
          {org_items}
        </DropdownButton>
      </td>

      <td><b><input type="text" required="required" placeholder="Enter name" name="name" value={editFormData.name} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter email" name="email" value={editFormData.email} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter phone" name="phone" value={editFormData.phone} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter username" name="username" value={editFormData.username} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter password" name="password" value={editFormData.password} onChange={handleEditFormChange} ></input></b></td>
      {/*<td><b><input type="text" required="required" placeholder="Enter level" name="level" value={editFormData.level} onChange={handleEditFormChange} ></input></b></td>*/}
      <td>
        <DropdownButton title={(editFormData.level !== undefined ? editFormData.level + ' - ' + level_descriptions.find(x => Number(x.level) === Number(editFormData.level))['description'] : '')} onSelect={handleEditFormSelect}>
          <Dropdown.Item name="level" eventKey={1}>1 - View</Dropdown.Item>
          <Dropdown.Item name="level" eventKey={2}>2 - Maintenance</Dropdown.Item>
          <Dropdown.Item name="level" eventKey={3}>3 - Admin</Dropdown.Item>
        </DropdownButton>
      </td>
      <td>
        <button className="btn btn-primary" type="button" onClick={handleCancelClick}>Cancel</button>
        <button className="btn btn-primary" type="submit">Save</button>
      </td>
    </tr>
  )
}



//const Personnel = ({personnel, main_callback}) => {
const Personnel = ({database, main_callback}) => {
  var personnel = database['personnel'];
  var organizations = database['organizations'];

  //console.log('personnel', personnel)
/*
  // TODO: Tähän jäi...
  let organizations_list = new Object();
  console.log('personnel organizations', database['organizations'])
  let organizations_test = database['organizations'].map(org => {
    console.log('personnel', org.id, org.name)
    organizations_list.push((org.id, org.name))
  });
  console.log(organizations_list);
      //const ref = useRef(personnel['email']);
    //const [ value, setValue ] = useState("");
    */
/*
    const [ kaikki, setKaikki ] = useState([]);
    console.log('personnel', personnel, kaikki)
    if (personnel && kaikki.length == 0) {
        setKaikki(personnel);
    }

    if (!personnel) 
        return;

    

    const handleChange = (event) => {
        event.preventDefault();

        console.log(handleChange, event)

    }
*/





    const [show, setShow] = useState(false);
    const [editPersonId, setEditPersonId] = useState(null);
    const [editFormData, setEditFormData] = useState([]);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [rowIdToDelete, setRowIdToDelete] = useState(null);
  

    const eventFromChild = (event) => {
        console.log('event from child', event)
        // TODO: Laitetaanko tähän tallennus vai viedäänkö Appin tasolle?
        // Suljettaessa formia tulee ainoastaan teksti close
        if (event !== "close")
            main_callback('add', 'personnel', event);
        
        setShow(false);
      }


  // Edit kenttää muutettu
  const handleEditFormChange = (event) => {
    console.log('edit change', event)
    //event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);

    console.log('edit changed', newFormData)
  };

  // Valittu alasvetovalikosta
  const handleEditFormSelect = (eventKey, event)  => {
    const fieldName = event.target.getAttribute("name");
    const fieldValue = eventKey;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };

  // Editoitavalla rivillä painetaan save-nappia
  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    const editedPerson = {
      id: editPersonId,
      organization_id: editFormData.organization_id,
      name: editFormData.name,
      email: editFormData.email,
      phone: editFormData.phone,
      username: editFormData.username,
      password: editFormData.password,
      level: editFormData.level
    }

    const newPersonnel = [...personnel];
    const index = personnel.findIndex((person) => person.id === editFormData.id);
    newPersonnel[index] = editFormData;
    //setEditFormData(newOrganization);
    console.log('edit submit', editPersonId, newPersonnel)
    
    main_callback('update', 'personnel', newPersonnel);
    
    setEditPersonId(null);
  }

  // Editoitavalla painetaan cancel-nappia
  const handleCancelClick = () => {
    console.log('edit cancelled')
    setEditPersonId(null);
  }


  // ReadOnly-rivillä painetaan edit-nappia
  const handleEditClick = (event, person) => {
    console.log('edit click', event, person)
    event.preventDefault();
    setEditPersonId(person.id);

    const formValues = {
      id: person.id,
      organization_id: person.organization_id,
      name: person.name,
      email: person.email,
      phone: person.phone,
      username: person.username,
      password: person.password,
      level: person.level
    };

    console.log('edit click form', formValues)

    setEditFormData(formValues);
    console.log('edit click after', editFormData)
  };


  // Read-only rivillä painetaan deleteä -> näytetään varmistusdialogi (alla)
  const handleDeleteRow = (id) => {
    console.log('handleDeleteRow', id)
    setRowIdToDelete(id);

    // Kysytään varmistus poistoon
    setShowConfirmation(true);
  }

  // Jos käyttäjä vahvistaa poiston -> lähetetään backendille poistettavan rivin id
  const confirmation_callback = (confirmation) =>{
    if (confirmation === "confirm") {
      main_callback('delete', 'personnel', rowIdToDelete)
      setRowIdToDelete(null);
    }

    // Piiletetaan lopuksi vahvistusdialogi
    setShowConfirmation(false);
  }

  
    

  return (
    <>
      <h2>Henkilöt</h2>
      <form onSubmit={handleEditFormSubmit}>
        <Table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Org Id</th>
              <th>Nimi</th>
              <th>Email</th>
              <th>Puhelin</th>
              <th>Käyttäjätunnus</th>
              <th>Salasana</th>
              <th>Level</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {personnel.map((person) => (
              <Fragment key={person.id}>
                {editPersonId === person.id ? (
                  <EditableRow editFormData={editFormData} handleEditFormChange={handleEditFormChange} handleCancelClick={handleCancelClick} handleEditFormSelect={handleEditFormSelect} organizations={organizations} />
                ) : (
                  <ReadOnlyRow person={person} handleEditClick={handleEditClick} handleDeleteRow={handleDeleteRow} organizations={organizations} />
                )}

              </Fragment>
            ))}
          </tbody>


        </Table>
      </form>

      <PersonAdd show={show} callback={eventFromChild}></PersonAdd>

      <Confirmation className="delete-confirmation" show={showConfirmation} callback={confirmation_callback}></Confirmation>

      <button
        class="btn btn-primary"
        onClick={() => setShow(true)}>
        Lisää
      </button>
    </>
  )
}

export default Personnel;